export var containerLss = {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    bg: 'opacity',
    p: 'lg',
    zIndex: 'footer',
    flexDirection: 'column',
    alignItems: 'center',
    tablet: { flexDirection: 'row' }
};
export var linkLss = {
    color: 'secondary500',
    textDecoration: 'none',
    ':visited': {
        color: 'secondary500'
    }
};
export var footerTextLss = {
    textScale: 'caption',
    textAlign: 'center',
    ml: 'none',
    tablet: { ml: 'md' }
};
//# sourceMappingURL=styles.js.map